import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{enum/plant-asset-area-type @record.type}}")